import {FormControl, InputLabel, MenuItem, Select, Autocomplete, TextField, Typography, Box} from "@mui/material";
import get from "lodash.get";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {getSearchIllnesessData} from "../../utils/API";

function SelectComponent4(props) {
    const {
        menuItem = [],
        suggestionillnessList = [],
        label,
        setSelections,
        required = false,
        procedureName = null,
        multiple = false,
        mode,
        minWidth = "120px",
    } = props;
    const [selection, setSelection] = useState(
        mode === "entity"
            ? {
                displayName: "Initimation Number",
                id: "INTIMATION_NUMBER",
            }
            : mode === "date"
                ? { id: "DATE_UPDATED", name: "Updated Date" }
                : ""
    );
    const handleChange = (event) => {
        setSelection(event.target.value);
    };
    const handleAutocompleteChange = (event, value) => {
        setSelection(value);
    };

    useEffect(() => {
        setSelections(selection);
    }, [selection]);
    useEffect(() => {
        if (Array.isArray(menuItem) && menuItem.length > 0) {
            setMenuItemSet(menuItem);
        }
    }, [menuItem]);

    const [menuItemSet, setMenuItemSet] = useState([menuItem]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

    const searchIllness = async (keyword) => {
        if (!keyword || keyword.length < 2) return;

        setLoading(true);

        try {
            const res = await getSearchIllnesessData(keyword);

            // ✅ extract array safely (adjust path if needed)
            const list =
                Array.isArray(res?.data)
                    ? res.data
                    : Array.isArray(res?.data?.data)
                        ? res.data.data
                        : Array.isArray(res?.data?.data?.illnessList)
                            ? res.data.data.illnessList
                            : [];

            setMenuItemSet(list);
        } catch (error) {
            console.error("Search illness failed", error);
            setMenuItemSet([]); // fallback
        } finally {
            setLoading(false);
        }
    };
    // const suggestedIllnessList = [
    //     "Haemorrhoids Grade III-K64.9:Others",
    //     "Piles-K64.9:Others",
    //     "Cold"
    // ];


    return (
        <div>
            <FormControl
                variant="standard"
                fullWidth
                sx={{ m: 1, minWidth: minWidth }}
            >
                <InputLabel id="demo-simple-select-standard-label" required={required}>
                    {label}
                </InputLabel>
                {!multiple &&


                    <Autocomplete
                        id="illness-autocomplete"

                        // ✅ Suggested options always on top
                        options={[
                            ...menuItemSet.filter((item) =>
                                suggestionillnessList?.some(
                                    (suggested) =>
                                        suggested?.illnessName === item?.illnessName
                                )
                            ),

                            ...menuItemSet.filter(
                                (item) =>
                                    !suggestionillnessList?.some(
                                        (suggested) =>
                                            suggested?.illnessName === item?.illnessName
                                    )
                            ),
                        ]}

                        getOptionLabel={(option) =>
                            option?.illnessName || ""
                        }

                        // ✅ Disable inactive options
                        getOptionDisabled={(option) =>
                            option.active === false &&
                            option.illnessName !== "Select"
                        }

                        // ✅ Selected value
                        value={
                            menuItemSet.find(
                                (item) => item?.id === selection?.id
                            ) || null
                        }

                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    value: newValue || "",
                                },
                            });
                        }}

                        // ✅ Match selected option
                        isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                        }

                        inputValue={inputValue}

                        loading={loading}

                        onInputChange={(event, newInputValue) => {
                            const searchText = newInputValue?.toString();

                            setInputValue(searchText);

                            if (!searchText || searchText.length < 2) return;

                            const exists = menuItemSet.some((item) =>
                                item?.illnessName
                                    ?.toLowerCase()
                                    .includes(searchText.toLowerCase())
                            );

                            if (!exists) {
                                searchIllness(searchText);
                            }
                        }}

                        clearOnEscape

                        // ✅ Custom dropdown UI
                        renderOption={(props, option) => {
                            const isSuggested =
                                suggestionillnessList?.some(
                                    (suggested) =>
                                        suggested?.illnessName ===
                                        option?.illnessName
                                );

                            return (
                                <li
                                    {...props}
                                    style={{
                                        padding: "10px 14px",
                                        borderBottom: "1px solid #f0f0f0",
                                        opacity:
                                            option.active === false
                                                ? 0.5
                                                : 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                variant="body2"
                                                fontWeight={500}
                                            >
                                                {option.illnessName}
                                            </Typography>

                                            {/*{option.active === false && (*/}
                                            {/*    <Typography*/}
                                            {/*        variant="caption"*/}
                                            {/*        color="error"*/}
                                            {/*    >*/}
                                            {/*        Inactive*/}
                                            {/*    </Typography>*/}
                                            {/*)}*/}
                                        </Box>

                                        {/* ✅ Suggested Badge */}
                                        {isSuggested && (
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: "#1976d2",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                Suggested
                                            </Typography>
                                        )}
                                    </Box>
                                </li>
                            );
                        }}

                        // ✅ Input UI
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={procedureName || ""}
                                variant="standard"
                                InputLabelProps={{
                                    style: {
                                        color: "#000",
                                    },
                                }}
                            />
                        )}
                    />
                }
                {multiple && <Autocomplete
                    multiple
                    id="tags-standard"
                    sx={{ mt: '1rem' }}
                    options={menuItemSet}
                    getOptionLabel={(option) =>
                        option?.illnessName
                            ? `${option.illnessName}`
                            : "Select"
                    }
                    onChange={handleAutocompleteChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                        />
                    )}

                    inputValue={inputValue}           // ✅ TEXT
                    loading={loading}
                    onInputChange={(event, newInputValue, reason) => {
                        // if (reason !== "input") return; // ✅ ignore reset/clear

                        const searchText = newInputValue?.toString();

                        setInputValue(searchText);

                        if (!searchText || searchText.length < 2) return;

                        const exists = menuItemSet.some(item =>
                            item.illnessName
                                ?.toLowerCase()
                                .includes(searchText.toLowerCase())
                        );

                        if (!exists) {
                            searchIllness(searchText); // ✅ STRING ONLY
                        }
                    }}
                />}
            </FormControl>
        </div>
    );
}

export default SelectComponent4;
